import { render } from "./OnDemandOrderDetails.vue?vue&type=template&id=37c18784&scoped=true"
import script from "./OnDemandOrderDetails.vue?vue&type=script&lang=js"
export * from "./OnDemandOrderDetails.vue?vue&type=script&lang=js"

import "./OnDemandOrderDetails.vue?vue&type=style&index=0&id=37c18784&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c18784"]])

export default __exports__